export default __webpack_public_path__ + "static/media/even.482a950b.svg";